const Inicio = () => {
    return (
        <main className="main">
            {/* Inicio */}
            <section id="hero" className="hero section">
                <div className="container">
                    <div className="row align-items-center">
                    <div className="col-lg-5">
                        <div className="hero-image" data-aos="fade-right" data-aos-delay="100">
                        <img src="assets/images/clinica.png" alt="Healthcare Professional" className="img-fluid main-image" />
                        <div className="floating-card emergency-card" data-aos="fade-up" data-aos-delay="300">
                            <div className="card-content">
                                <i className="bi bi-whatsapp"></i>
                                <div className="text">
                                    <span className="label">WhatsApp</span>
                                    <span className="number">449 427 27 28</span>
                                </div>
                            </div>
                        </div>
                        <div className="floating-card stats-card" data-aos="fade-up" data-aos-delay="400">
                            <div className="stat-item">
                                <span className="number">25K+</span>
                                <span className="label">Pacientes atendidos</span>
                            </div>
                            <div className="stat-item">
                                <span className="number">98%</span>
                                <span className="label">Satisfacción</span>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="col-lg-7">
                        <div className="hero-content" data-aos="fade-left" data-aos-delay="200">
                            <div className="badge-container">
                                <span className="hero-badge">Veterinaria Tostes</span>
                            </div>

                            <h1 className="hero-title">Excelencia médica y profesional</h1>
                            <p className="hero-description"><b>Tostes</b> brinda un servicio excepcional en el cuidado de animales, convirtiéndose en un pilar fundamental para la comunidad de <b>Aguascalientes</b>. Con un enfoque en la atención accesible, ofrece instalaciones de primer nivel.</p>

                            <div className="hero-stats">
                                <div className="stat-group">
                                    <div className="stat">
                                        <i className="bi bi-award"></i>
                                        <div className="stat-text">
                                            <span className="number">20+</span>
                                            <span className="label">Años de experiencia</span>
                                        </div>
                                    </div>
                                    <div className="stat">
                                        <i className="bi bi-people"></i>
                                        <div className="stat-text">
                                            <span className="number">15+</span>
                                            <span className="label">Especialistas médicos</span>
                                        </div>
                                    </div>
                                    <div className="stat">
                                        <i className="bi bi-geo-alt"></i>
                                        <div className="stat-text">
                                            <span className="number">1</span>
                                            <span className="label">Hospital</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="background-elements">
                    <div className="bg-shape shape-1"></div>
                    <div className="bg-shape shape-2"></div>
                    <div className="bg-pattern"></div>
                </div>
            </section>

            {/* Contacto */}
            <section id="contact" className="contact section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4">
                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="info-box">
                                <i className="bi bi-geo-alt"></i>
                                <h3>Ubicación</h3>
                                <p>Av Aguascalientes Sur #503<br />Bulevares 1ra Secc, 20288 Aguascalientes, Ags.</p>
                            </div>
                        </div>

                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="info-box">
                                <i className="bi bi-telephone"></i>
                                <h3>Teléfonos</h3>
                                <p>449 913 60 41<br />449 978 02 34</p>
                            </div>
                        </div>

                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="400">
                            <div className="info-box">
                                <i className="bi bi-envelope"></i>
                                <h3>Correo</h3>
                                <p>recepcion.tostes@gmail.com</p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-4 mt-4">
                        <div className="col-lg-12" data-aos="fade-up" data-aos-delay="500">
                            <div className="map-container">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.957437040642!2d-102.3046028!3d21.859177400000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee66db738c03%3A0xdbbaa2ff124abb9d!2sTOSTES!5e0!3m2!1ses!2smx!4v1767655120485!5m2!1ses!2smx" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Inicio;